/**
 * Created by agengmaulana on 5/3/17.
 */
import React from 'react'
import styles from './../../assets/css/comment.css'


export default class Comment_Empty_Data extends React.Component {

    render(){
        const {wording,wording2} = this.props;
        return(
            <div className={styles.cmt_no_komen}>
                <strong>{wording}</strong><br/>
                {wording2}<br/><br/>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./static/src/component/comment_empty_data/comment_empty_data.js